import { render } from "./CompleteTheSetV2.vue?vue&type=template&id=708210f7&scoped=true"
import script from "./CompleteTheSetV2.vue?vue&type=script&lang=js"
export * from "./CompleteTheSetV2.vue?vue&type=script&lang=js"

import "./CompleteTheSetV2.vue?vue&type=style&index=0&id=708210f7&lang=scss&scoped=true"
import "./CompleteTheSetV2.vue?vue&type=style&index=1&id=708210f7&lang=css"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708210f7"]])

export default __exports__